module.exports = __webpack_public_path__ + "static/media/tarjeta_master.52ea5a49.svg";